/// <amd-module name="Wit/Settings/BoardsExternalIntegration/components/panels/ShowPanel.props" />
import { Panel } from "Wit/Settings/BoardsExternalIntegration/components/panels/Panel.enum";
import { ExternalConnection } from "Wit/Clients/Internal/Contracts/WorkItemTracking";

export interface IShowPanelProps {
    showPanel: (panel: Panel, connection?: ExternalConnection, onPanelClosed?: () => void, performOAuthCheck?: boolean, isGitHubApp?: boolean) => void;
}
